export enum LocalStorageEnum {
    PersonActing = 'PersonActing',
    PersonResponsible = 'PersonResponsible',
    MatterAssistingResponsibility = 'MatterAssistingResponsibility',
    MatterIntroducingResponsibility = 'MatterIntroducingResponsibility',
    ApplicationTerminology = 'ApplicationTerminology',
}